import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, retry, delay } from "rxjs/operators";

import { CookiesService } from "../services/cookies.service";
import { Environment } from "./../environments/environment";

@Injectable()
export class UsersService {
  private usersServiceEndPoint: string;
  private tokenGeneratorEndPoint: string;
  private tokenApiKey: string;
  private usersAPIKey: string;
  private accessToken: string;
  private oeURL: string;

  currentEnvironment = this.getCurrentEnvironment();

  constructor(
    private cookiesService: CookiesService,
    private http: HttpClient,
    private environment: Environment
  ) {
    this.usersServiceEndPoint = environment.getEnvironmentVariable(
      "usersServiceEndPoint"
    );
    this.tokenGeneratorEndPoint = environment.getEnvironmentVariable(
      "tokenGeneratorEndPoint"
    );
    this.tokenApiKey = environment.getEnvironmentVariable("tokenApiKey");
    this.usersAPIKey = environment.getEnvironmentVariable("usersAPIKey");
    this.oeURL = environment.getEnvironmentVariable("oe_url");
  }

  public getOrderExpressURL() {
    return this.oeURL;
  }

  public getUsersData(): Observable<any> {
    if (this.currentEnvironment === "localhost") {
      return this.http
        .get(this.usersServiceEndPoint)
        .pipe(retry(1), catchError(this.handleError));
    } else {
      return this.http
        .get(
          this.usersServiceEndPoint +
            "/pd/ecom/v1/users/" +
            this.getUserDataFromSessionStorage().userDisplayName +
            "?fields=firstName,lastName,email,mobileNumber,shipTos.id,shipTos.name,shipTos.city,shipTos.address1,shipTos.address2,shipTos.state,shipTos.zipCode,shipTos.alias,shipTos.distributionCenter,shipTos.customerNumber,shipTos.marketingPrograms,shipTos.marketingPrograms.code,shipTos.marketingPrograms.description,shipTos.marketingPrograms.effectiveDate,shipTos.marketingPrograms.endDate,userSettings.memberGroups,orderUser&include=shipTos,userSettings,rolesAndPrivileges&shipTos.includeMarketingPrograms=active",
          this.getHeadersForUsersAPI(),
        )
        .pipe(retry(1), catchError(this.handleError));
    }
  }

  public callTokenGenerator(): Observable<any> {
    if (this.currentEnvironment === "localhost") {
      return this.http
        .get(this.tokenGeneratorEndPoint)
        .pipe(retry(1), catchError(this.handleError));
    } else {
      var apiURL =
        this.tokenGeneratorEndPoint +
        "/api/v1/token-generator/generate?user=" +
        this.getUserDataFromSessionStorage().userDisplayName;
      return this.http
        .get(apiURL, this.getHeadersForTokenGenerator())
        .pipe(retry(1), catchError(this.handleError));
    }
  }

  public getAccessToken() {
    this.callTokenGenerator().subscribe(
      (data) => {
        this.accessToken = data.access_token;
        sessionStorage.setItem("accessToken", this.accessToken);
      },
      (error) => {}
    );
  }

  handleError(error) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }

  handleErrorToken(error) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    if (error.statusText.indexOf("Unauthorized") > -1) {
      let env = new Environment();
      var currentURL = window.location.href;
      window.location.href =
        env.getEnvironmentVariable("oe_url") +
        "/eps/mycah/HomeRI?authredirect=" +
        currentURL;
    }

    return throwError(errorMessage);
  }

  getHeadersForTokenGenerator(): any {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-api-key": this.tokenApiKey,
        "sm-session": this.cookiesService.getCookie("SMSESSION"),
      }),
    };
    return httpOptions;
  }

  getHeadersForUsersAPI(): any {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-api-key": this.usersAPIKey,
        Authorization: sessionStorage.getItem("accessToken"),
      }),
    };
    return httpOptions;
  }

  getUserDataFromSessionStorage() {
    return JSON.parse(sessionStorage.getItem("userDataObject"));
  }

  getCurrentEnvironment(): string {
    return window.location.hostname;
  }
}
